import { FC } from 'react'
import { Box, Collapse } from '@mui/material'
import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline'
import ErrorOutlineIcon from '@mui/icons-material/ErrorOutline'
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined'
import {
  GREEN_COLORS_VARIANTS,
  NEGATIVE_COLORS_VARIANTS,
  PRIMARY_COLORS_VARIANTS,
  TEXT_DARK_COLORS_VARIANTS,
} from '@/utils/constants/colors'

export type CfStatus = 'success' | 'failed' | 'cancelled' | null

const STATUS_CONFIG: Record<
  NonNullable<CfStatus>,
  { icon: typeof CheckCircleOutlineIcon; bgcolor: string; color: string; text: string }
> = {
  success: {
    icon: CheckCircleOutlineIcon,
    bgcolor: GREEN_COLORS_VARIANTS[250],
    color: GREEN_COLORS_VARIANTS[700],
    text: 'Payment successful! Your wallet will be credited shortly once the transaction is confirmed.',
  },
  failed: {
    icon: ErrorOutlineIcon,
    bgcolor: NEGATIVE_COLORS_VARIANTS[200],
    color: NEGATIVE_COLORS_VARIANTS[400],
    text: 'Payment failed. Please try again.',
  },
  cancelled: {
    icon: InfoOutlinedIcon,
    bgcolor: PRIMARY_COLORS_VARIANTS[200],
    color: TEXT_DARK_COLORS_VARIANTS[400],
    text: 'Deposit cancelled. No funds were taken.',
  },
}

type PaymentStatusBannerProps = {
  status: CfStatus
}

export const PaymentStatusBanner: FC<PaymentStatusBannerProps> = ({ status }) => {
  if (!status) return null

  const cfg = STATUS_CONFIG[status]
  const Icon = cfg.icon

  return (
    <Collapse in timeout={400}>
      <Box
        display="flex"
        alignItems="center"
        gap={1.25}
        p={1.75}
        borderRadius="0.75rem"
        bgcolor={cfg.bgcolor}
        border={`1px solid ${cfg.color}33`}
      >
        <Icon sx={{ color: cfg.color, fontSize: '1.25rem', flexShrink: 0, mt: 0.125 }} />
        <Box component="p" fontSize="0.875rem" fontWeight={600} color={cfg.color} lineHeight={1.5}>
          {cfg.text}
        </Box>
      </Box>
    </Collapse>
  )
}
